module.exports = __webpack_public_path__ + "static/scale-model-of-white-plains-park-in-yonkers-new-york-1b5fedfe7ebe0a36e9dd54f477f70f6e.png";